module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7wNUE"))).then(() => parcelRequire('5erN3'));